import { apiClient } from "@base/api/client";
import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import {
  type DailyLogEditRequest,
  type DailyLogEditResponse,
  dailyLogEditRequestSchema,
  dailyLogEditResponseSchema,
} from "./editDailyLogSchema";

async function editDailyLog(
  projectId: string,
  dailyLogId: string,
  body: DailyLogEditRequest,
): Promise<DailyLogEditResponse> {
  const parsedBody = dailyLogEditRequestSchema.parse(body);
  const response = await apiClient.put<unknown>(
    `/project-management/api/projects/${projectId}/daily-logs/${dailyLogId}`,
    parsedBody,
  );
  return dailyLogEditResponseSchema.parse(response.data);
}

export function useEditDailyLogMutation(
  projectId: string,
  dailyLogId: string,
  options?: Omit<UseMutationOptions<DailyLogEditResponse, Error, DailyLogEditRequest>, "mutationFn">,
) {
  return useMutation({
    mutationFn: (body: DailyLogEditRequest) => editDailyLog(projectId, dailyLogId, body),
    ...options,
  });
}
